import {
  LeadGenerationBuilders,
  MediaAdvert,
  PaidServicesAndBenefits,
  PrimaryRealEstate,
  SecondaryMarket,
} from './components';
import { useToScroll } from 'shared/hooks/useToScroll';

export const CoreBusiness: React.FC = () => {
  useToScroll();

  return (
    <>
      <SecondaryMarket />
      <PaidServicesAndBenefits />
      <PrimaryRealEstate />
      <LeadGenerationBuilders />
      <MediaAdvert />
    </>
  );
};
